/** Stable category and subcategory grouping for the chart's indicator picker. */
export const INDICATOR_SECTIONS = [
  { key: "trend", label: "Trend" },
  { key: "momentum", label: "Momentum" },
  { key: "volatility", label: "Volatility" },
  { key: "volume", label: "Volume" },
  { key: "orderflow", label: "Order flow" },
  { key: "patterns", label: "Patterns" },
];

export function indicatorSubcategory(indicator = {}) {
  const name = String(indicator.fullLabel || indicator.label || "").toLowerCase();
  if (indicator.group === "trend") {
    if (/moving average|sma|ema|wma|hma|dema|tema|guppy|alligator|vwma|smma|vidya|vma|trima|tsma/.test(name)) return "Moving averages";
    if (/band|channel|envelope|donchian|keltner|ichimoku|cloud/.test(name)) return "Bands & channels";
    return "Trend direction";
  }
  if (indicator.group === "momentum") {
    if (/rsi|stochastic|williams|cci|fisher|psych|imi/.test(name)) return "Oscillators";
    if (/macd|roc|momentum|trix|ppo|kst|coppock|schaff/.test(name)) return "Momentum";
    return "Trend strength";
  }
  if (indicator.group === "volatility") return /band|channel|range|envelope/.test(name) ? "Bands & ranges" : "Volatility measures";
  if (indicator.group === "volume") return /obv|cmf|money flow|accumulation|distribution|klinger|volume|vwap/.test(name) ? "Volume flow" : "Volume indicators";
  if (indicator.group === "orderflow") return /profile/.test(name) ? "Market profiles" : "Footprint & delta";
  if (indicator.group === "patterns") return /candle|doji|hammer|engulf|star|harami|fractal/.test(name) ? "Candlestick patterns" : "Chart patterns";
  return "Other";
}

/** Search and group a mixed catalog while retaining each definition exactly once. */
export function groupIndicatorDefinitions(definitions, { searchTerm = "", hiddenKeys = [] } = {}) {
  const query = String(searchTerm).trim().toLowerCase();
  const hidden = new Set(hiddenKeys);
  const items = (Array.isArray(definitions) ? definitions : []).filter((indicator) => {
    if (!indicator?.key || hidden.has(indicator.key)) return false;
    if (!query) return true;
    return `${indicator.label || ""} ${indicator.fullLabel || ""} ${indicator.summary || ""}`.toLowerCase().includes(query);
  });
  return INDICATOR_SECTIONS.map((section) => {
    const sectionItems = items.filter((indicator) => indicator.group === section.key);
    const buckets = new Map();
    sectionItems.forEach((indicator) => {
      const label = indicatorSubcategory(indicator);
      if (!buckets.has(label)) buckets.set(label, []);
      buckets.get(label).push(indicator);
    });
    return {
      ...section,
      items: sectionItems,
      subgroups: Array.from(buckets, ([label, subgroupItems]) => ({ label, items: subgroupItems })),
    };
  }).filter((section) => section.items.length > 0);
}
